export default __webpack_public_path__ + "static/1297-62397c7338c7e123ec9ea9fdcc0080fd.gif";